import { Fragment } from 'react';
import { useTheme } from '@shopify/polaris-viz-core';
import { ZERO_VALUE_LINE_HEIGHT } from '../../../constants.js';
import { jsx } from 'react/jsx-runtime';

function getZeroValueLineCoords({
  x,
  y,
  direction,
  areAllNegative
}) {
  if (direction === 'vertical') {
    return {
      x1: x,
      x2: x,
      y1: y,
      y2: !areAllNegative ? y - ZERO_VALUE_LINE_HEIGHT : y + ZERO_VALUE_LINE_HEIGHT
    };
  }

  return {
    x1: x,
    x2: !areAllNegative ? x + ZERO_VALUE_LINE_HEIGHT : x - ZERO_VALUE_LINE_HEIGHT,
    y1: y,
    y2: y
  };
}

function ZeroValueLine({
  x,
  y,
  theme,
  direction = 'vertical',
  areAllNegative
}) {
  const selectedTheme = useTheme(theme);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx("line", {
      stroke: selectedTheme.bar.zeroValueColor,
      strokeWidth: "1",
      ...getZeroValueLineCoords({
        x,
        y,
        direction,
        areAllNegative
      })
    })
  });
}

export { ZeroValueLine };
